export const MenuGroupKeys = {
    paging: "getMenuGroupPaging",
    delete: "deleteMenuGroup",
    get: "getMenuGroupById",
    update: "updateMenuGroup",
    create: "createMenuGroup"
}